import { getStorage, ref, uploadBytes, getBlob, deleteObject } from "firebase/storage";
import { app } from "./firebase";
const storage = getStorage(app);
/** 파일의 공개 토큰 URL을 저장하지 않고 인증된 Storage 경로로 읽습니다. */
export const storageService = {
  async uploadFile(file: File, path: string): Promise<string> {
    try { await uploadBytes(ref(storage, path), file); return '';  }
    catch { throw new Error("파일 업로드를 완료하지 못했습니다. 접근 권한을 확인해 주세요."); }
  },
  async readFile(path: string): Promise<Blob> {
    if (!path || path.startsWith('http') || path.includes('..')) throw new Error('인증된 파일 경로가 필요합니다.');
    try { return await getBlob(ref(storage, path)); }
    catch { throw new Error('현재 파일을 열 수 없습니다. 접근 권한을 확인해 주세요.'); }
  },
  async deleteFile(path: string): Promise<void> {
    try { await deleteObject(ref(storage, path)); }
    catch { throw new Error("파일 삭제를 완료하지 못했습니다. 접근 권한을 확인해 주세요."); }
  }
};
